import React from 'react';
const styles = require('./index.less');

export default function EmptyDataTip() {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyInner}>
        <div className={styles.frame} />
        <div className={styles.iconTip} />
        敬请期待
      </div>
      <div className={styles.emptyShadow}>
        <div className={styles.frame} />
        <div className={styles.iconTip} />
        敬请期待
      </div>
    </div>
  );
}
